import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'
import { getMappedValue } from '../utils/arabicUtils'

const CellItem = ({
  label,
  value = '',
  children,
  isPWA = true,
  isFlexStart = false,
  childClass = null,
  boldValue = false,
  valueClass = null,
  height = '',
  upgradeDetails = {}
}) => (
  <React.Fragment>
    <div className="flex-1" key={`cell_item_${Math.random()}`}>
      <If condition={label}>
        <div
          className={`flex flex-middle ${isFlexStart ? 'flex-start' : 'flex-between'
          } ${childClass || (isPWA ? 'fs-15' : 'fs-body')} ${!isPWA && height === '' &&
            'flex-middle'}`}
          key={`cell_item_child_${Math.random()}`}
        >
          <p
            className={`min-max-20 pr-2 tt-sentence color-8a fw-600 fs-12 ${label ===
              'fare type' && height === 'h-72' &&
              !isPWA &&
              'mt-3'}`}
          >
            {getMappedValue(label)}
          </p>
          <div
            className={`flex-1 flex-middle ${label !== 'fare type' && !isPWA && 'flex'} ${isFlexStart ? 'flex-start' : 'flex-end'
            }`}
            key={`cell_item_child_value_${Math.random()}`}
          >
            <If condition={children}>
              {children}
              <Else />
              <p
                className={`us-text ${boldValue ? 'fw-600' : ''} ${valueClass ||
                  ''}`}
              >
                {value}
              </p>
              <If condition={upgradeDetails && upgradeDetails.type}>
                <Tooltip
                  arrow={true}
                  theme="dark"
                  html={(
                    <div style={{
                      width: '229px',
                      padding: '12px 14px',
                      textAlign: 'initial'
                    }}
                    >
                      <p className="fs-2 c-white">{upgradeDetails.desc}</p>
                    </div>
                  )}
                >
                  <span className="ml-2 flex flex-middle">
                    {upgradeDetails.icon}
                  </span>
                </Tooltip>

              </If>
            </If>
          </div>
        </div>
      </If>
    </div>
  </React.Fragment>
)

const ListWrapper = ({ children, noBorder, isRelatedRow }) => (
  <li
    className={`flex flex-between flex-middle h-48 ${isRelatedRow ? 'pr-4' : 'pl-4'
    } ${noBorder ? '' : 'border-bottom-grey'}`}
  >
    {children}
  </li>
)
const CellWrapper = ({ children, noBorder, isRelatedRow, height }) => (
  <div
    className={`flex flex-between flex-middle ${height || 'h-48'} ${isRelatedRow ? 'pr-4' : 'pl-4'
    } ${noBorder ? '' : 'border-bottom-grey'}`}
    key={`cell_wrapper_${Math.random()}`}
  >
    {children}
  </div>
)
const DesktopRowItem = props => {
  let { type } = props
  const { noBorder, isRelatedRow, height } = props
  type = type || 'individual_cell'
  let returnItem = null
  switch (type) {
    case 'list':
      returnItem = (
        <ListWrapper isRelatedRow={isRelatedRow} noBorder={noBorder}>
          <CellItem {...props} />
        </ListWrapper>
      )
      break
    default:
    case 'individual_cell':
      returnItem = (
        <CellWrapper
          isRelatedRow={isRelatedRow}
          noBorder={noBorder}
          height={height}
        >
          <CellItem {...props} />
        </CellWrapper>
      )
      break
    case 'dynamic':
      returnItem = (
        <CellWrapper
          isRelatedRow={isRelatedRow}
          noBorder={noBorder}
          height={height}
        >
          <CellItem {...props} />
        </CellWrapper>
      )
      break
  }
  return returnItem
}
DesktopRowItem.defaultProps = {
  label: null,
  value: null,
  hasArrow: false,
  isRelatedRow: false,
  clickHandler: () => { },
  leftItem: null,
  rightItem: null
}
DesktopRowItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasArrow: PropTypes.bool,
  isRelatedRow: PropTypes.bool,
  clickHandler: PropTypes.func,
  leftItem: PropTypes.element,
  rightItem: PropTypes.element,
  rowType: PropTypes.oneOf(['list', 'individual_cell', 'dynamic']).isRequired
}
export default DesktopRowItem
